import { useState, useEffect } from "react";
import { Avatar, Spinner } from "@heroui/react";
import type { User } from "../model/types";
import { getUserInitials, getAvatarGradient, getUserAvatarUrl } from "../lib/avatar";

export interface UserAvatarProps {
  user?: User | null;
  name?: string | null;
  email?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
  showImage?: boolean;
}

export const UserAvatar = ({
  user,
  name,
  email,
  size = "sm",
  className = "",
  showImage = true,
}: UserAvatarProps) => {
  const displayName = name ?? user?.display_name ?? null;
  const userEmail = email ?? user?.email ?? null;

  const initials = getUserInitials(displayName, userEmail);
  const gradient = getAvatarGradient(displayName || userEmail);
  const avatarUrl = showImage
    ? (user?.avatar_url || (displayName ? getUserAvatarUrl(displayName) : undefined))
    : undefined;

  const [isImageLoading, setIsImageLoading] = useState(Boolean(avatarUrl));

  useEffect(() => {
    setIsImageLoading(Boolean(avatarUrl));
  }, [avatarUrl]);

  return (
    <Avatar size={size} className={className}>
      {avatarUrl && (
        <Avatar.Image
          src={avatarUrl}
          alt={displayName || "Пользователь"}
          loading="lazy"
          onLoadingStatusChange={(status) => {
            setIsImageLoading(status === "loading");
          }}
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />
      )}
      <Avatar.Fallback
        className={`bg-gradient-to-tr ${gradient} text-white font-semibold flex items-center justify-center select-none shadow-sm`}
      >
        {isImageLoading ? (
          <Spinner
            size="sm"
            className={`${size === "sm" ? "scale-75" : "scale-90"} text-white`}
          />
        ) : (
          initials
        )}
      </Avatar.Fallback>
    </Avatar>
  );
};
